import React from 'react';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import Text from './base/Text';
import { Flex } from './base/layout-components';
import { isNaN } from 'lodash';

const ColoredLine = styled.div`
  height: 3.5rem;
  width: 0.3rem;
  margin-right: 1rem;
  border-radius: 2rem;
  background-color: ${({ color }) => getColor(color)};
`;
const Wrapper = styled(Flex)`
  ${({ padding }) => (padding ? `padding:${padding};` : '')}
`;

const ColoredPercentileItem = ({
  percent = 0,
  color,
  text,
  padding,
  textFirst,
  ...rest
}) => {
  const displayPercent = !isNaN(percent) ? `${percent}%` : '-';
  const displayText = textFirst ? text.toUpperCase() : text;
  const dataCy = `work-breakdown-${displayText
    .toLowerCase()
    .replace(/\s+/g, '-')}-value`;
  return (
    <Wrapper padding={padding} items='center' {...rest}>
      {color && <ColoredLine color={color} />}
      <Flex justify='center' direction='column' align='center'>
        {textFirst ? (
          <>
            <Text color='shuttleGray' size='large'>
              {displayText}
            </Text>
            <Text size='x-large' weight='bold' data-cy={dataCy}>
              {displayPercent}
            </Text>
          </>
        ) : (
          <>
            <Text
              size='x-x-x-large'
              letterSpacing='0.04rem'
              weight='bold'
              data-cy={dataCy}
            >
              {displayPercent}
            </Text>
            <Text letterSpacing='0.08rem' color='shuttleGray' size='medium'>
              {displayText}
            </Text>
          </>
        )}
      </Flex>
    </Wrapper>
  );
};

export default ColoredPercentileItem;
